enum DesignStatusEnum {
    fixing = 1,
    checking = 2,
    adopted = 3,
    inProduction = 4, // lock button in this situation from 4 to 8\9
    cancel = 5,
    requestReturn = 8, // Запрос на отправку в работу
    requestRework = 9, // Запрос на отправку на доработку
}

export default DesignStatusEnum;
